import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            name: "login",
            meta: {main_page: true},
            component: () => import("@/core/plugins/TitleRibbon/index"),
            children: [
                {
                    path: "/dashboard",
                    name: "dashboard",
                    meta: {
                        has_ribbon: false,
                        main_page: true
                    },
                    component: () => import("@/core/plugins/TitleRibbon/Dashboard")
                },
                {
                    path: "/divarNews",
                    name: "sendADS",
                    component: () =>
                        import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
                    children: [
                        {
                            path: "new",
                            name: "new",
                            meta: {
                                permission: 'recent_list',
                                has_ribbon: true,
                                title: "تازه های دیوار"
                            },
                            component: () => import("@/view/pages/divar/divarNews/divarNews")
                        },
                        {
                            path: "list",
                            name: "recent_list",
                            meta: {
                                permission: 'recent_list',
                                has_ribbon: true,
                                title: "لیست تازه های دیوار"
                            },
                            component: () => import("@/view/pages/divar/divarNews/divarNewsList.vue")
                        },
                    ]
                },
                {
                    path: "/customers",
                    name: "customers",
                    component: () =>
                        import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
                    children: [
                        {
                            path: "list",
                            name: "list",
                            meta: {
                                permission: 'customer_list',
                                has_ribbon: true,
                                title: "لیست مشتریان"
                            },
                            component: () => import("@/view/pages/divar/customer/customersList.vue")
                        },
                    ]
                },
                {
                    path: "/estates",
                    name: "estates",
                    component: () =>
                        import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
                    children: [
                        {
                            path: "list",
                            name: "estate_list",
                            meta: {
                                permission: 'estate_list',
                                has_ribbon: true,
                                title: "لیست فایل های من"
                            },
                            component: () => import("@/view/pages/divar/states/estateList.vue")
                        },
                    ]
                },
                {
                    path: "/reminders",
                    name: "reminders",
                    component: () =>
                        import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
                    children: [
                        {
                            path: "list",
                            name: "list",
                            meta: {
                                permission: 'customer_history_list',
                                has_ribbon: true,
                                title: "لیست اعلانات"
                            },
                            component: () => import("@/view/pages/divar/reminders/remindersList.vue")
                        },
                    ]
                },
                {
                    path: "/archives",
                    name: "archives",
                    component: () =>
                        import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
                    children: [
                        {
                            path: "list",
                            name: "list",
                            meta: {
                                permission: 'estate_list',
                                has_ribbon: true,
                                title: "لیست بایگانی"
                            },
                            component: () => import("@/view/pages/divar/states/archives")
                        },
                    ]
                },
                {
                    path: "/consultant",
                    name: "list",
                    component: () =>
                        import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
                    children: [
                        {
                            path: "list",
                            name: "list",
                            meta: {
                                permission: 'agent_list',
                                has_ribbon: true,
                                title: "لیست مشاوران "
                            },
                            component: () => import("@/view/pages/divar/moshaver/list.vue")
                        },
                    ]
                },
            ]
        },
    ]
});
